import React from 'react';
import { Banknote } from 'lucide-react';


export default function A5PaymentVoucher({ voucherData, onClose }) {


  // Calculate totals
  const totalRs = voucherData.items.reduce((sum, item) => sum + (parseFloat(item.rs) || 0), 0);
  // const totalCts = voucherData.items.reduce((sum, item) => sum + (parseFloat(item.cts) || 0), 0);

  const formatNumber = (num) => {
    return Number(num).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    // Split the date string (YYYY-MM-DD)

    if( typeof dateString === 'number'){
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      
      return `${day}/${month}/${year}`;
    }else{
      const [year, month, day] = dateString.split('-');
    
      // Create date object (month is 0-indexed, so subtract 1)
      const date = new Date(year, month - 1, day);
      
      // Get day, month, year
      const d = String(date.getDate()).padStart(2, '0');
      const m = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const y = date.getFullYear();
      
      return `${d}/${m}/${y}`;
    }
   
};

  const TRANSFER_METHODS = [
    { value: 'peoples_bank', label: "People's Bank" },
    { value: 'seylan_bank', label: 'Seylan Bank' },
    { value: 'cash', label: 'Cash' }
  ];

  const getTransferMethodLabel = (val) => {
    if (!val) return '';
    const method = TRANSFER_METHODS.find(m => m.value === val);
    return method ? method.label : val;
  };

  console.log("Voucher Data:", voucherData);

  return (
    <>
    
    <style jsx global>{`
      @media print {
  /* Reset all margins and padding for print */
  body, html {
    margin: 0 !important;
    width: 100% !important;
    height: 100% !important;
    overflow: hidden !important;
  }

  /* Hide scrollbars completely */
  ::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  * {
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }

  /* Target the modal container specifically */
  .voucher-modal {
    overflow: hidden !important;
    height: auto !important;
    max-height: none !important;
    position: static !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  /* A5 paper container styling */
  .min-h-screen {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 148mm !important;
    height: 210mm !important;
    margin: 0 !important;
    background: white !important;
    visibility: visible !important;
    overflow: hidden !important;
    box-sizing: border-box !important;
  }

  /* Hide all interactive elements */
  button, .print-hide-complete {
    display: none !important;
  }

  /* Show only the content we want printed */
  .min-h-screen * {
    visibility: hidden;
  }

  /* Make the main container visible */
  .min-h-screen {
    visibility: visible !important;
  }

  /* Hide all decorative elements and labels */
  .text-blue-800,
  .font-medium,
  .text-lg,
  .bg-blue-50,
  .bg-blue-50 *,
  .border-gray-300,
  .border-blue-600,
  .border-dotted {
    color: transparent !important;
   border-color: transparent !important;
    background: transparent !important;
  }

  /* Hide label spans specifically */
  .min-h-screen span.text-sm.mr-2.text-blue-800.font-medium,
  .min-h-screen span.text-sm.mr-1.text-blue-800.font-medium {
    visibility: hidden !important;
  }

  /* Show only the data value spans with high specificity */
  .min-h-screen .border-b-2.border-dotted.border-blue-600 {
    visibility: visible !important;
    color: #000 !important;
    border: none !important;
    background: transparent !important;
    font-size: 15px !important;
    font-weight: normal !important;
  }

  /* Show icons inside visible data fields */
  .min-h-screen .border-b-2.border-dotted.border-blue-600 img,
  .min-h-screen .border-b-2.border-dotted.border-blue-600 svg {
    visibility: visible !important;
  }

  /* Position form field values to align with dotted lines */

  /* Date field - reduced spacing */
  .min-h-screen .dateAl + span.border-b-2 {
    margin-top: 11px !important;
    margin-left: 8px !important;
    display: inline-block !important;
  }

  /* Voucher number - reduced spacing */
  .min-h-screen .noAl + span.border-b-2.border-dotted.border-blue-600 {
    margin-top: -320px !important;
    margin-right: 36px !important;
    display: inline-block !important;
    font-size: 20px !important;
    font-weight: bold !important;
  }

  /* Payable to field - reduced spacing */
  .min-h-screen .payableAl + span.border-b-2 {
    margin-top: -1px !important;
    margin-left: 15px !important;
    display: inline-block !important;
  }

  /* Transfer Method field - reduced spacing */
  .min-h-screen .transferAl + .border-b-2 {
    margin-top: -1px !important;
    margin-left: 15px !important;
    display: inline-block !important;
  }

  /* Cash/cheque field - reduced spacing */
  .min-h-screen .cashAl {
    margin-top: -2px !important;
    margin-left: 15px !important;
    display: inline-block !important;
  }

  /* PO number - reduced spacing */
  .min-h-screen .poAl + span.border-b-2 {
    margin-top: -5px !important;
    margin-left: 40px !important;
    display: inline-block !important;
  }

  /* GRN number - reduced spacing */
  .min-h-screen .grnAl {
    margin-top: -3px !important;
    margin-right: 80px !important;
    display: inline-block !important;
  }

  /* Table content positioning */

  /* Show table item descriptions and position them properly */
.min-h-screen .border-2.border-blue-800 .description-cell .text-sm {
  visibility: visible !important;
  color: #000 !important;
  font-size: 15px !important;
  margin-top: -27px !important;
  margin-left: 5px !important;
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  line-height: 1.3 !important;
}
    .description-cell .text-sm {
  white-space: pre-wrap; /* Add this line for screen view */
}



  /* Show and position RS amounts in table rows */
.min-h-screen .border-2.border-blue-800 .amount-cell .text-sm {
  visibility: visible !important;
  color: #000 !important;
  font-size: 15px !important;
  margin-top: -27px !important;
  margin-left: 5px !important;
  line-height: 1.3 !important;
}

.min-h-screen .border-2.border-blue-800 .flex.border-b.border-blue-800 {
  min-height: auto !important;
  height: auto !important;
}

.min-h-screen .description-cell {
  display: flex !important;
  align-items: flex-start !important;
  padding-top: 10px !important;
  padding-left: 20px !important;
  padding-bottom: 10px !important;
  min-height: 32px !important;
  height: auto !important;
}

.min-h-screen .amount-cell {
  display: flex !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  padding-top: 10px !important;
  padding-left: 2px !important;
  padding-bottom: 10px !important;
  min-height: 32px !important;
  height: auto !important;
}
.min-h-screen .border-2.border-blue-800 > div > div.flex {
  align-items: stretch !important;
}

.min-h-screen .total-cell {
  position: relative !important;
}


  /* Show and position total amount - Fixed this section */
  .min-h-screen .total-cell span {
   position: absolute !important;
  visibility: visible !important;
  color: #000 !important;
  font-size: 15px !important;
  font-weight: bold !important;
  display: inline-block !important;
  top: 20px !important;
  left: 0 !important;
}

  /* Hide signature section values */
  .min-h-screen .grid.grid-cols-3 .border-b-2.border-dotted.border-blue-600 span {
    visibility: hidden !important;
  }

  /* Prevent page breaks */
  .mx-auto {
    page-break-inside: avoid;
    page-break-after: avoid;
  }

  /* Additional fine-tuning for table alignment */
  .min-h-screen .border-2.border-blue-800 {
    margin-top: 5px !important;
  }

  /* Ensure proper spacing for the entire form */
  .min-h-screen .p-3 {
    padding-top: 10px !important;
  }
}

/* Screen view styles (unchanged) */
.table-cell-top-align {
  vertical-align: top !important;
  padding-top: 2px !important;
}

.description-cell {
  display: flex !important;
  align-items: flex-start !important;
  padding-top: 10px !important;
  padding-left: 20px !important;
  padding-bottom: 10px !important;
  min-height: 32px !important;
  height: auto !important;
}

.amount-cell {
  display: flex !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  padding-top: 10px !important;
  padding-left: 2px !important;
  padding-bottom: 10px !important;
  min-height: 32px !important;
  height: auto !important;
}

.flex-1.border-r-2.border-blue-800.py-1.total-cell {
  visibility: visible !important;
  display: flex !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  padding-top: 20px !important;
  padding-left: 2px !important;
}



        
    `}</style>
    
      
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="voucher-modal bg-white rounded-lg overflow-hidden shadow-xl max-h-[90vh] overflow-y-auto">
            {/* A5 Paper Container - 148mm × 210mm */}
            <div 
              className="bg-white border border-gray-300 mx-auto relative min-h-screen"
              style={{
                width: '148mm',
                height: '210mm',
                minHeight: '210mm'
              }}
            >
              <button
                onClick={onClose}
                className="absolute top-2 sm:top-4 right-2 sm:right-4 z-10 bg-red-500 text-white rounded-full w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center hover:bg-red-600 text-base sm:text-lg print-hide-complete"
              >
                ×
              </button>
              <div className="w-full h-full p-3">
                <div className="h-full text-xs leading-tight flex flex-col">
                  
                  {/* Header */}
                  <div className="mb-2">
                    <div className="flex items-start">
                      <div className="w-20 sm:w-28 h-20 sm:h-28 flex items-center justify-center mr-0 sm:mr-6 mb-4 sm:mb-0">
                        <img
                          src="/netgatelogo.png"
                          alt="NetGate Lanka Logo"
                          className="w-full h-full object-contain"
                        />
                      </div>
                      <div className="text-blue-800 flex-1 text-center">
                        <div className="font-bold text-lg mb-1">NetGate Lanka (Pvt) Ltd.</div>
                        <div className="text-sm mb-1">No. 251/1A, Moratuwa Road, Piliyandala.</div>
                        <div className="text-sm mb-2">Tel: 070 166 6777</div>
                        <div className="text-center">
                          <div className="border-2 border-blue-800 inline-block px-4 py-2">
                            <div className="font-bold text-base">PAYMENT VOUCHER</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
      
                  {/* Form Fields */}
                  <div className="flex-1 flex flex-col">
                    
                    {/* Date and Number Row */}
                    <div className="flex justify-between mb-3">
                      <div className="flex items-center">
                        <span className="text-sm mr-1 text-blue-800 font-medium dateAl">Date :</span>
                        <span className="border-b-2 border-dotted border-blue-600  min-w-24 text-sm">
                        {formatDate(voucherData.date)}
                        </span>
                      </div>
                      <div className="flex items-center">
                        <span className="text-sm mr-1 text-blue-800 font-medium noAl">No.</span>
                        <span className="border-b-2 border-dotted border-blue-600  min-w-20 font-bold text-sm">
                          {voucherData.voucherNo}
                        </span>
                      </div>
                    </div>
      
                    {/* Payable To */}
                    <div className="mb-3">
                      <div className="flex items-center w-full">
                        <span className="text-sm mr-1 text-blue-800 font-medium payableAl">Payable to :</span>
                        <span className="border-b-2 border-dotted border-blue-600  flex-1 text-sm">
                          {voucherData.payableTo}
                        </span>
                      </div>
                    </div>
      
                    {/* Transfer Method and Cheque Details */}
                    <div className="flex flex-col sm:flex-row mb-3 gap-3">
                      <div className="flex items-center flex-1 print-hide-complete">
                        <span className="text-sm mr-1 text-blue-800 font-medium transferAl">Transfer Method :</span>
                        <div className="border-b-2 border-dotted border-blue-600 flex-1 text-sm flex items-center h-full">
                          {voucherData.transferMethod === "peoples_bank" && (
                            <img src="/peoples_bank.png" alt="People's Bank" className="w-5 h-5 mr-2 object-contain" />
                          )}
                          {voucherData.transferMethod === "seylan_bank" && (
                            <img src="/seylan_bank.png" alt="Seylan Bank" className="w-5 h-5 mr-2 object-contain" />
                          )}
                          {voucherData.transferMethod === "cash" && (
                            <Banknote className="w-5 h-5 mr-2 text-green-600" />
                          )}
                          <span>
                            {getTransferMethodLabel(voucherData.transferMethod)}
                          </span>
                        </div>
                      </div>
                      <div className="flex items-center flex-1">
                        <span className="text-sm mr-1 text-blue-800 font-medium">Cheque/Cash/Online :</span>
                        <span className="border-b-2 border-dotted border-blue-600 flex-1 text-sm cashAl">
                          {voucherData.chequeDetails}
                        </span>
                      </div>
                    </div>
      
                    {/* PO and GRN Numbers */}
                    <div className="flex justify-between mb-4">
                      <div className="flex items-center">
                        <span className="text-sm mr-1 text-blue-800 font-medium poAl">P.O. No.</span>
                        <span className="border-b-2 border-dotted border-blue-600  min-w-20 text-sm">
                          {voucherData.poNo}
                        </span>
                      </div>
                      <div className="flex items-center">
                        <span className="text-sm mr-1 text-blue-800 font-medium">G.R.N. No.</span>
                        <span className="border-b-2 border-dotted border-blue-600 min-w-20 text-sm grnAl">
                          {voucherData.grnNo}
                        </span>
                      </div>
                    </div>
      
                    {/* Table */}
                    <div className="border-2 border-blue-800 mb-4 flex-1 flex flex-col">
                      {/* Table header */}
                      <div className="text-center text-sm font-medium">
                        <div className="flex border-b-2 border-blue-800 bg-blue-50">
                          <div className="flex-1 border-r-2 border-blue-800 py-2">
                            Description
                          </div>
                          <div className="w-32">
                            <div className="py-2 border-b border-blue-800">
                              Amount
                            </div>
                            <div className="flex">
                              <div className="flex-1 py-2 border-r-2 border-blue-800">
                                Rs
                              </div>
                              <div className="flex-1 py-2">
                                Cts
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
      
                      {/* Table content */}
                      <div className="flex-1 flex flex-col">
                        {/* Data rows */}
                        {voucherData.items.map((item, index) => (
                          <div key={index} className="flex border-b border-blue-800 min-h-8">
                            <div className="flex-1 border-r-2 border-blue-800 p-1 description-cell">
                              <div className="w-full text-sm whitespace-pre-wrap">{item.description}</div>
                            </div>
                            <div className="w-32 flex">
                              <div className="flex-1 border-r-2 border-blue-800 p-1 amount-cell">
                                <div className="w-full text-sm"> {formatNumber(item.rs)}</div>
                              </div>
                              <div className="flex-1 p-1">
                                {/* <div className="w-full py-1 text-center text-sm centAl">{String(item.cts).split('.')[0]}</div> */}
                              </div>
                            </div>
                          </div>
                        ))}
      
                        {/* Empty space filler */}
                        <div className="flex flex-1 min-h-12">
                          <div className="flex-1 border-r-2  border-blue-800"></div>
                          <div className="w-32 flex">
                            <div className="flex-1 border-r-2  border-blue-800"></div>
                            <div className="flex-1"></div>
                          </div>
                        </div>
                      </div>
      
                      {/* Total row */}
                      <div className="border-t-2 border-blue-800 text-center text-sm font-bold bg-blue-50">
                        <div className="flex">
                          <div className="flex-1 border-r-2 border-blue-800 py-2">
                            Total
                          </div>
                          <div className="w-32 flex">
                            <div className="flex-1 border-r-2 border-blue-800 py-2 total-cell">
                              <span>{formatNumber(totalRs)}</span>
                            </div>
                            <div className="flex-1 py-2">
                              {/* <span>{totalCts.toString().padStart(2, '0')}</span> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
      
                    {/* Bottom signature section */}
                    <div className="grid grid-cols-3 gap-4 text-sm">
                      <div className="text-center">
                        <div className="w-full  px-2 py-3 text-center mb-2 min-h-8">
                          {/* <span className="text-sm">{voucherData.preparedBy}</span> */}
                        </div>
                        {/* <div className="text-blue-800 font-medium">Prepared by</div> */}
                      </div>
                      <div className="text-center">
                        <div className="w-full  px-2 py-3 text-center mb-2 min-h-8">
                          {/* <span className="text-sm">{voucherData.authorisedBy}</span> */}
                        </div>
                        {/* <div className="text-blue-800 font-medium">Authorised by</div> */}
                      </div>
                      <div className="text-center">
                        <div className="w-full  px-2 py-3 text-center mb-2 min-h-8">
                        {/* <div className="w-full border-b-2 border-dotted border-blue-600 px-2 py-3 text-center mb-2 min-h-8"> */}
                          {/* <span className="text-sm">{voucherData.receiverSignature}</span> */}
        </div>
                        {/* <div className="text-blue-800 font-medium">Signature of Receiver</div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
      
            {/* Print Button */}
            <div className="flex justify-center mt-4 pb-4">
              <button
                onClick={() => window.print()}
                className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors text-sm font-medium print-hide-complete"
              >
                Print Voucher
              </button>
            </div>
          </div>
        </div>
      </>
      );


}